import type {
    FC
} from "react";
import {
    type GestureResponderEvent,
    Pressable,
    Platform
} from "react-native";
import type ILinkBlockProps from "./type";
import {
    useStyles
} from "./stylesheet";
import {
    useInteractionState
} from "../../../../helpers/interaction";
import {
    MARKDOWN_LINK_HREF_ATTRS
} from "../../constant";
import {
    handleMarkdownLinkPress
} from "../../util";
import StateLayer from "../../../stateLayer";
import stylesheet from "../../stylesheet";

const MarkdownLinkBlock: FC<ILinkBlockProps> = ({
    linkContainerProps,
    shapeConfigs,
    customTheme,
    onLinkPress,
    children,
    radiuses,
    borders,
    colors,
    url
}) => {
    const {
        interactionHandlers,
        isFocusVisible,
        isHovered,
        isPressed
    } = useInteractionState({
        onPressOut: linkContainerProps?.onPressOut,
        onPressIn: linkContainerProps?.onPressIn,
        onFocus: linkContainerProps?.onFocus,
        onBlur: linkContainerProps?.onBlur
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        isFocusVisible,
        shapeConfigs,
        radiuses,
        borders,
        colors
    });

    const onPress = (event: GestureResponderEvent) => {
        handleMarkdownLinkPress({
            onLinkPress,
            event,
            url
        });
    };

    const webLinkProps = Platform.OS === "web" ? {
        hrefAttrs: MARKDOWN_LINK_HREF_ATTRS,
        href: url
    } : {};

    return <Pressable
        {...linkContainerProps}
        {...webLinkProps}
        {...interactionHandlers}
        style={[
            linkContainerProps?.style,
            stylesheet.linkBlock,
            containerDynamicStyle
        ]}
        onPress={onPress}
        role="link"
    >
        <StateLayer
            borderRadius={radiuses.form}
            customTheme={customTheme}
            isHovered={isHovered}
            isPressed={isPressed}
        />
        {children}
    </Pressable>;
};
export default MarkdownLinkBlock;
